module.exports = __webpack_public_path__ + "static/media/ehealth_personal_folder_banner_mobile.2e4fdd12.jpg";